"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { getPageFromPath, getPathForPage } from "@/config/navigation";
import type { Page } from "@/types";

export function useAppNavigation() {
  const pathname = usePathname();
  const router = useRouter();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const page = getPageFromPath(pathname || "/");

  useEffect(() => {
    if (pathname === "/") {
      router.replace(getPathForPage("overview"));
    }
  }, [pathname, router]);

  const changePage = (nextPage: Page) => {
    const nextPath = getPathForPage(nextPage);
    if (pathname !== nextPath) {
      router.push(nextPath);
    }
  };

  return { page, changePage, sidebarCollapsed, setSidebarCollapsed };
}
